export const cap100 = (n: number) => {
  if (n > 99) {
    return "99+";
  } else if (n < -99) {
    return "-99+";
  }

  return n.toString();
};
